/** Волны и забежка. */
import { Coins } from "../../common";
import { Empty } from "../errors";
import type { EndpointDef } from "../endpoint";
import { PlayerState } from "../player";
import { ReviveBoostRequest } from "../../monetization";
import { WaveLog, WaveResult } from "../../wave-log";
import { z } from "zod";

/** Вердикт сервера по журналу волны. */
export const WaveVerdict = z.enum([
  /** Итог совпал, начислено. */
  "accepted",
  /** Итог не совпал: начислено по серверному пересчёту, клиент откатывается к `state`. */
  "corrected",
  /** Этот журнал уже принят: ответ тот же, повторно не начислено. */
  "duplicate",
]);
export type WaveVerdict = z.infer<typeof WaveVerdict>;

/** Ответ на журнал волны. */
export const SubmitWaveResponse = z.object({
  verdict: WaveVerdict,
  /** Итог по серверному пересчёту. */
  result: WaveResult,
  /** Начислено монет за волну. */
  coinsAwarded: Coins,
  /** Подтверждённое состояние после волны (новая забежка — если волна проиграна). */
  state: PlayerState,
});
export type SubmitWaveResponse = z.infer<typeof SubmitWaveResponse>;

/** Выход из забежки: усиления сгорают, начинается новая забежка с текущей волны. */
export const ExitRunRequest = z.object({
  reason: z.enum(["closed", "backgroundTimeout", "manual"]),
});

export const waveEndpoints = {
  /** Сдать журнал волны. */
  submitWave: { method: "POST", path: "/api/waves", request: WaveLog, response: SubmitWaveResponse, auth: true },
  /** Выйти из забежки. */
  exitRun: { method: "POST", path: "/api/run/exit", request: ExitRunRequest, response: PlayerState, auth: true },
  /** Бесплатный реванш VIP (MADR 0007); платный идёт через счёт. */
  revive: { method: "POST", path: "/api/run/revive", request: Empty, response: PlayerState, auth: true },
  /** Выбрать усиление подкрепления после реванша (MADR 0019); нет выбора или вариант не тот — `conflict`. */
  reviveBoost: {
    method: "POST",
    path: "/api/run/revive/boost",
    request: ReviveBoostRequest,
    response: PlayerState,
    auth: true,
  },
} as const satisfies Record<string, EndpointDef>;
